var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-sur-header'),_c('common-header',{attrs:{"nav-items":_vm.header.navItems,"cta-buttons":_vm.header.ctaButtons}}),_c('bloc-maif-title'),(_vm.assuranceName === 'MAIF')?_c('bloc-decouvrir-pop-valet'):_vm._e(),_c('bloc-fonctionnement-solution'),_c('bloc-nos-methodes'),_c('common-footer',{attrs:{"is-maif":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }